const theme = {
  colors: {
    yellow: "yellow",
    black: "black",
    white: "white",
  },

  breakpoint: {
    mobileMax: 767,
  },
};

export default theme;
